import React from 'react';
import { Card, Skeleton } from '@mui/material';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';

const formatDuration = (minutes) => {
  if (minutes >= 60) {
    return {
      value: (minutes / 60).toFixed(2),
      unit: 'hr Avg.'
    };
  }
  return {
    value: '',
    unit: ''
  };
};

const StatItem = ({ label, minutes, loading }) => {
  const formatted = formatDuration(minutes);
  return (
    <div className="bg-white rounded p-3 mb-2">
      {loading ? (
        <>
          <Skeleton variant="text" width="60%" height={24} />
          <Skeleton variant="text" width="40%" height={20} />
        </>
      ) : (
        <div className="flex flex-col">
          <div className="flex items-baseline gap-1">
            <span className="text-xl font-medium">{formatted.value}</span>
            <span className="text-sm text-gray-500">{formatted.unit}</span>
          </div>
          <div className="text-sm text-gray-500">{label}</div>
        </div>
      )}
    </div>
  );
};

const MHEAvailabilityCard = ({ data, loading }) => {
  const unsafeMheDate = data.date[0]?.unique_count;
  console.log('mhe', data.date[0]?.unique_count);

  return (
    <div>
      <Card
        className="border relative border-gray-300"
        sx={{
          height: '276px',
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
          borderRadius: '8px'
        }}
      >
        <div className="flex w-full flex-col gap-1 p-3">
          <div className="flex items-center gap-2">
            <PrecisionManufacturingIcon className="bg-emerald-500 text-white rounded-full p-2 text-6xl" />

            <div style={{ width: loading ? '120px' : 'auto' }}>
              {loading ? (
                <>
                  <Skeleton variant="text" width="100%" height={40} />
                  <Skeleton variant="text" width="80%" height={28} />
                </>
              ) : (
                <>
                  {/* <div className="flex items-baseline">
                    <span className="text-3xl font-medium">{formattedAvailability.value}</span>
                    <span className="text-sm text-gray-500 ml-1">{formattedAvailability.unit}</span>
                  </div> */}
                  <p className="text-lg font-semibold">Unsafe MHE</p>
                </>
              )}
            </div>
          </div>
          <div className="bg-slate-100 flex-grow overflow-y-auto h-[184px] p-2 rounded-lg scrollbar">
            <div className="text-xs text-gray-500 mb-2 italic">More Statistics</div>
            <StatItem
              label={
                <>
                  <span className="text-2xl font-semibold text-black">{unsafeMheDate ?? 0}</span>
                  <br />
                  <span className="text-sm text-gray-500">Unsafe MHE Movements</span>
                </>
              }
            />
          </div>
        </div>
      </Card>
    </div>
  );
};

export default MHEAvailabilityCard;
